/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Team_Manager_Add_Users_SuccessInputs */



/**
* | output |
* | --- |
* | "Your team can now have {limit} users." |
*
* @param {Team_Manager_Add_Users_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_users_success = /** @type {((inputs: Team_Manager_Add_Users_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Users_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Votre équipe peut désormais compter ${i?.limit} utilisateurs.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Team kann jetzt ${i?.limit} Benutzer haben.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il team ora può avere ${i?.limit} utenti.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Теперь в команде может быть ${i?.limit} пользователей.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Tu equipo ya puede tener ${i?.limit} usuarios.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您的团队现在最多可有 ${i?.limit} 个用户。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`チームのユーザー上限が ${i?.limit} 人になりました。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अब आपकी टीम में ${i?.limit} उपयोगकर्ता हो सकते हैं।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A sua equipa pode agora ter ${i?.limit} utilizadores.`)
	return /** @type {LocalizedString} */ (`Your team can now have ${i?.limit} users.`)
});